import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref } from "vue";
const _hoisted_1 = { class: "documents-card-top" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "documents-card-text" };
const _hoisted_4 = { class: "documents-card-title" };
const _hoisted_5 = {
    key: 0,
    class: "documents-card-subtitle"
};
const _hoisted_6 = {
    key: 1,
    class: "documents-card-subtitle"
};
const _hoisted_7 = {
    key: 0,
    class: "documents-card-subtitle"
};
const _hoisted_8 = {
    key: 1,
    class: "documents-card-subtitle"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "documents-card-bottom" };
const _hoisted_11 = { class: "documents-card-whatsapp-icon" };
const _hoisted_12 = ["src"];
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentsInfoPanel',
    props: {
        documentCount: {},
        categoryCount: {},
        variant: { default: 'documents' }
    },
    setup(__props) {
        const router = useRouter();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "documents-card",
                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push(_ctx.variant === 'payslips' ? '/Payslips' : '/Documents')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: require('@/assets/document.png'),
                        class: "documents-card-icon",
                        alt: _ctx.variant === 'payslips' ? 'Payslips' : 'Documents'
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.variant === 'payslips' ? 'My Payslips' : 'My Documents'), 1),
                        (_ctx.variant === 'payslips')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                ((_ctx.documentCount ?? 0) > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                        _cache[1] || (_cache[1] = _createTextVNode("You've added ")),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.documentCount) + " " + _toDisplayString(_ctx.documentCount === 1 ? 'payslip' : 'payslips'), 1),
                                        _cache[2] || (_cache[2] = _createTextVNode("."))
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_6, "Send payslips via WhatsApp for automatic analysis."))
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                ((_ctx.documentCount ?? 0) > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                        _cache[3] || (_cache[3] = _createTextVNode("You've added ")),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.documentCount) + " " + _toDisplayString(_ctx.documentCount === 1 ? 'document' : 'documents'), 1),
                                        _cache[4] || (_cache[4] = _createTextVNode(" across ")),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.categoryCount) + " " + _toDisplayString(_ctx.categoryCount === 1 ? 'category' : 'categories'), 1),
                                        _cache[5] || (_cache[5] = _createTextVNode("."))
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_8, "Send documents via WhatsApp for automatic analysis."))
                            ], 64))
                    ]),
                    _createElementVNode("img", {
                        src: require('@/assets/arrow-right.png'),
                        class: "documents-card-arrow"
                    }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                            src: require('@/assets/whatsapp.png'),
                            alt: "WhatsApp"
                        }, null, 8, _hoisted_12)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "documents-card-bottom-text" }, "Powered by your WhatsApp AI Assistant.", -1))
                ])
            ]));
        };
    }
});
